import { Image } from "antd";
import themeLogo from "../../../assets/images/theme-logo.png";

function Logo(props) {
  const { width = 54, src = themeLogo } = props;
  return <Image preview={false} src={src} width={width} />;
}

export default Logo;
